<div class="row m-0 p-1">
    <div class="col-lg-12 m-0 p-1">
        <div class="bg-white rounded shadow">
            <div class="row m-0 p-0 ">
                <div class="col-lg-3 d-flex my-auto">
                    <div class="custom-search ">
                        <input type="filter" class="custom-search-input" placeholder="Search for" autocomplete="off" tabindex="1" (input)="onSearchChange($event.target.value)">
                    </div>

                </div>
                <div class="col-lg-6 d-flex">
                    <div class="form-group">
                        <label >Asset Type:</label>
                        <select #assettype class="custom-select round dropdown_W" (change)="onAssetTypeChange(assettype.value)">
                          <option value="">Select Asset Type</option>
                          <option *ngFor="let data of AssetsDataLists" [value]="data.id">{{data.name}}</option>
                        </select>
                    </div>
    
                    <div class="form-group ml-3">
                        <label >Creative:</label>
                        <select #creative  class="custom-select round dropdown_W" (change)="onCreativeChange(creative.value)">
                        <option value="">Select Creative</option>
                        <option *ngFor="let data of CreativeDataLists" [value]="data.id">{{data.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-3 d-flex my-auto">

                </div>
            </div>
        </div>
    </div>
</div>

<div class="row m-0 p-1">     
    <div class="col-lg-12 m-0 p-1"> 
        <div class="bg-white rounded shadow p-3">

            <div class="col-lg-12 grt-showroom">
                <owl-carousel-o [options]="customOptions">
                    <ng-template  carouselSlide class="d-flex" *ngFor="let data of ShowroomDataLists;let i=index">
                        <ul class="row slide" >
                            <li class="box pointer" [ngClass]="{ active: s_ShowroomID === data.id}" (click)="selectShowroom(data.id,data.name)">
                                <img class="img-fluid z-depth-1"
                                onerror="this.src='/assets/grt.svg'" src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}"
                                alt="">
                                <p class="text-black text-center font15 font-weight-bold">{{data.name}}</p>
                            </li> 
                        </ul>
                    </ng-template>
                </owl-carousel-o>
            </div>
            <!-- <div class="p-4" *ngIf="isShowTab">
                <ul id="myTab" role="tablist" class="nav nav-tabs nav-pills flex-column flex-sm-row text-center bg-light border-0 rounded-nav">
                    <li class="nav-item flex-sm-fill">
                    <a id="state-tab" data-toggle="tab" href="#state" role="tab" aria-controls="state" aria-selected="true" class="nav-link border-0 text-uppercase font-weight-bold active">Region</a>
                    </li>
                    <li class="nav-item flex-sm-fill">
                    <a id="showroom-tab" data-toggle="tab" href="#showroom" role="tab" aria-controls="showroom" aria-selected="false" class="nav-link border-0 text-uppercase font-weight-bold">Showroom</a>
                    </li>
                </ul>            
            </div>
            <div id="myTabContent" class="tab-content"  *ngIf="isShowTab">
                <div id="state" role="tabpanel" aria-labelledby="state-tab" class="tab-pane fade px-3 show active">
                    <div class="row mp-0">
                        <div class="col-3 my-1 mx-auto" *ngFor="let data of RegionDataLists;let i=index">
                            <div class="box p-1 pointer" (click)="onRegionClick(data.id,data.name)">
                                <img class="img-fluid z-depth-1"
                                onerror="this.src='/assets/grt.svg'" src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}"
                                alt="">
                                <p class="text-center text-black font-weight-bold text-uppercase mp-0">{{data.name}}</p>
                            </div>
                            </div>
                    </div>
                </div>

                <div id="showroom" role="tabpanel" aria-labelledby="showroom-tab" class="tab-pane fade px-3">
                    <div class="row mp-0">
                        <div class="col-3 my-1 mx-auto" *ngFor="let data of ShowroomDataLists;let i=index">
                            <div class="box p-1 pointer" (click)="showInstoreData(data.region_id,data.regionName,data.id,data.name)">
                                <img class="img-fluid z-depth-1"
                                onerror="this.src='/assets/grt.svg'" src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}"
                                alt="">
                                <p class="text-center text-black font-weight-bold text-uppercase mp-0">{{data.name}}</p>
                            </div>
                            </div>
                    </div>
                </div>
            </div>
            <div class=""  *ngIf="!isShowTab">
                <div class="title-header d-flex">
                    <div class="text-left col-10 my-auto">
                        <span class="text-muted">Region : </span><h5 class="m-0 p-0">{{selectedRegion}}</h5>
                    </div>
                    <div class="text-right col-2 my-auto">
                        <div class="back pointer">
                            <a (click)="onBackClick();"><i class="fa fa-long-arrow-left fa-lg"></i></a>
                        </div>
                    </div>
                
                </div>
                <div class="row mp-0">
                    <div class="col-3 my-1 mx-auto" *ngFor="let data of f_Region_Showroom_list;let i=index">
                        <div class="box p-1 pointer" (click)="showInstoreData(data.region_id,data.regionName,data.id,data.name)">
                            <img class="img-fluid z-depth-1"
                            onerror="this.src='/assets/grt.svg'" src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}"
                            alt="">
                            <p class="text-center text-black font-weight-bold text-uppercase mp-0">{{data.name}}</p>
                        </div>
                        </div>
                </div> 

            </div>-->
        </div>                                  
    </div>
</div>
<div class="row m-0 p-1">     
    <div class="col-lg-12 m-0 p-1 w-100"> 
        <div class="bg-white rounded shadow p-3">
            <div class="title-header"><h5 class="mp-0">Marketing Calendar for the 2021 - 2022</h5></div>
            <div class="div-newactivity tablecontain-allactivity margin-left-right mt-3">
                <table class="table border1" matSort (matSortChange) = "sortListItems($event)">
                    <thead>
                        <tr class="text-light ">         
                            <th class="pl-4 text-center max-wd">Campaign</th>      
                            <!-- <th class="pl-4 text-center">Category</th> -->
                            <th class="pl-4 text-center">April</th>
                            <th class="pl-4 text-center">May</th>
                            <th class="pl-4 text-center">June</th>
                            <th class="pl-2 text-center">July</th>
                            <th class="pl-2 text-center">Aug</th>
                            <th class="pl-2 text-center">Sep</th>
                            <th class="pl-4 text-center">Oct</th>
                            <th class="pl-4 text-center">Nov</th>
                            <th class="pl-4 text-center">Dec</th>
                            <th class="pl-4 text-center">Jan</th>
                            <th class="pl-4 text-center">Feb</th>
                            <th class="pl-4 text-center">Mar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of filter_tc_CampaignLists| slice: (page-1) * pageSize : page * pageSize;let i=index" >
                            <td><p class="m-0 p-0 font-weight-bold">{{data.name}}</p></td>
                            <!-- <td><div class=""></div></td> -->
                            <td [ngClass]="getTDClass(data.start_date, data.end_date, '04')"><div [ngClass]="getDivClass(data.start_date, data.end_date, '04')" (click)="getInfo(data)">{{getDay(data.start_date, data.end_date, "04")}}</div></td>
                            <td [ngClass]="getTDClass(data.start_date, data.end_date, '05')"><div [ngClass]="getDivClass(data.start_date, data.end_date, '05')"(click)="getInfo(data)">{{getDay(data.start_date, data.end_date, "05")}}</div></td>
                            <td [ngClass]="getTDClass(data.start_date, data.end_date, '06')"><div [ngClass]="getDivClass(data.start_date, data.end_date, '06')"(click)="getInfo(data)">{{getDay(data.start_date, data.end_date, "06")}}</div></td>
                            <td [ngClass]="getTDClass(data.start_date, data.end_date, '07')"><div [ngClass]="getDivClass(data.start_date, data.end_date, '07')"(click)="getInfo(data)">{{getDay(data.start_date, data.end_date, "07")}}</div></td>
                            <td [ngClass]="getTDClass(data.start_date, data.end_date, '08')"><div [ngClass]="getDivClass(data.start_date, data.end_date, '08')"(click)="getInfo(data)">{{getDay(data.start_date, data.end_date, "08")}}</div></td>
                            <td [ngClass]="getTDClass(data.start_date, data.end_date, '09')"><div [ngClass]="getDivClass(data.start_date, data.end_date, '09')"(click)="getInfo(data)">{{getDay(data.start_date, data.end_date, "09")}}</div></td>
                            <td [ngClass]="getTDClass(data.start_date, data.end_date, '10')"><div [ngClass]="getDivClass(data.start_date, data.end_date, '10')"(click)="getInfo(data)">{{getDay(data.start_date, data.end_date, "10")}}</div></td>
                            <td [ngClass]="getTDClass(data.start_date, data.end_date, '11')"><div [ngClass]="getDivClass(data.start_date, data.end_date, '11')"(click)="getInfo(data)">{{getDay(data.start_date, data.end_date, "11")}}</div></td>
                            <td [ngClass]="getTDClass(data.start_date, data.end_date, '12')"><div [ngClass]="getDivClass(data.start_date, data.end_date, '12')"(click)="getInfo(data)">{{getDay(data.start_date, data.end_date, "12")}}</div></td>
                            <td [ngClass]="getTDClass(data.start_date, data.end_date, '01')"><div [ngClass]="getDivClass(data.start_date, data.end_date, '01')"(click)="getInfo(data)">{{getDay(data.start_date, data.end_date, "01")}}</div></td>
                            <td [ngClass]="getTDClass(data.start_date, data.end_date, '02')"><div [ngClass]="getDivClass(data.start_date, data.end_date, '02')"(click)="getInfo(data)">{{getDay(data.start_date, data.end_date, "02")}}</div></td>
                            <td [ngClass]="getTDClass(data.start_date, data.end_date, '03')"><div [ngClass]="getDivClass(data.start_date, data.end_date, '03')"(click)="getInfo(data)">{{getDay(data.start_date, data.end_date, "03")}}</div></td>
                        </tr>
                    </tbody>
                    </table>
                    <div class="text-center p-5" *ngIf="filter_tc_CampaignLists && filter_tc_CampaignLists.length === 0" >
                        <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                            <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                          </svg>
                        <p class="m-0 no-record"> No Record Found </p>
                      </div>
            </div>
            <!--  <div class="mt-1 sl-pagination text-center justify-content-center d-flex">
                <ngb-pagination  [(page)]="page"
                [pageSize]="pageSize"
                [collectionSize]="sortedList.length" aria-label="Default pagination" class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
            </div>-->
        </div> 
    </div>
</div>
<div class="row m-0 p-1" *ngIf="festivalInfo && filter_tc_CampaignLists.length>0">     
    <div class="col-lg-12 m-0 p-1 w-100"> 
        <div class="bg-white rounded shadow p-3">
            <div class="title-header"><h5 class="mp-0">{{s_ShowroomName}} - {{festivalInfo.name}}</h5></div>
            <div class="details-info px-3">
                <div class="form-group row">
                    <div class="col-4 "><p>Start Date</p></div>
                    <div class="col-8 "><p>{{festivalInfo?.start_date}}</p></div>
                </div>
                <div class="form-group row">
                    <div class="col-4 "><p>End Date</p></div>
                    <div class="col-8 "><p>{{festivalInfo?.end_date}}</p></div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="col-lg-12 m-0 p-1"> 
        <div class="bg-white rounded shadow p-3">
            <div class="row ml-0 mr-0 pb-4">
                <div class="col-md-6 ">
                    <div class="text-center">
                            <img class="text-center current-image" src="assets/images/listdetail/banner_cal.png">
                    </div>
                </div>
                <div class="col-md-6 current-ad-border">
                    <form [formGroup]="form"  class="form-horizontal" (ngSubmit)="onSubmit()">
                        <fieldset>
                        
                        <div class="row  mt-0">
                            <div class="col-md-12">

                                    <div class="form-group row">
                                        <label class="col-md-5 control-label ml-0 mt-2" for="contact">Location :</label>  
                                        <div class="col-md-7">
                                        <input id="contact" type="text" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.location.errors }">
                                        <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
                                            <div *ngIf="f.location.errors.required">Location is required</div>
                                        </div> 
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-md-5 control-label ml-0 mt-2" for="contact">Type :</label>  
                                        <div class="col-md-7">
                                        <input id="contact" type="text" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.location.errors }">
                                        <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
                                        <div *ngIf="f.location.errors.required">Location is required</div>
                                        </div> 
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-md-5 control-label ml-0 mt-2" for="contact">Creative :</label>  
                                        <div class="col-md-7">
                                        <input id="contact" type="text" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.location.errors }">
                                        <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
                                        <div *ngIf="f.location.errors.required">Location is required</div>
                                        </div> 
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-md-5 control-label ml-0 mt-2" for="contact">Size :</label>  
                                        <div class="col-md-7">
                                        <input id="contact" formControlName="size" type="text" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.location.errors }">
                                        <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
                                        <div *ngIf="f.location.errors.required">Location is required</div>
                                        </div> 
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-md-5 control-label ml-0 mt-2" for="contact">Particulars :</label>  
                                        <div class="col-md-7">
                                        <input id="contact" formControlName="particulars" type="text" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.location.errors }">
                                        <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
                                        <div *ngIf="f.location.errors.required">Location is required</div>
                                        </div> 
                                        </div>
                                    </div>

                                    <div class="d-flex mt-3">
                                        <button class="btn-export ml-auto mr-4">Update</button>
                                        <button class="btn-export" >Modifty</button>
                                    </div>  
                            </div>  
                        </div>  
                        
                        </fieldset>
                        </form>
                </div>
            </div>
        </div>
    </div>-->
</div>